import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Projectgoal() {
  return (
    <section className="p-100 bg_textcolor" style={{ background: "#D76637" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>The Brief</h2>
            <p>
              According to IBIS World, the size of the auction industry in the
              US is $645.2 billion. Considering the market growth rate of 8.1%
              and more than 250,000 businesses participating, the auctions
              industry is well-positioned to grow faster than the retail
              industry.
            </p>
            <p>
              Additionally, with the technological advancements in the video
              industry, Ray (Our client) had this out-of-the-box idea of
              leveraging technology to transform the auction market. The
              transformational idea was to revolutionize the auction market by
              allowing users to shoot and edit high-definition videos and later
              auction them on virtual events.
            </p>
            <p>
              To ensure standardized quality and maximum impact, Ray turned to
              Tekrevol to mature the idea through solid industry research and
              get a complete digital solution.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectgoal;
